import React, { useContext, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  FormControl,
} from "@mui/material";
import { getColors } from "../../themes/theme";
import { useForm } from "react-hook-form";
import { ThemeContext } from "../../context/ThemeContext";
import { isEmail } from "class-validator";

export const EditUserDialog = ({
  open,
  onClose,
  userData,
  onDelete,
  onEdit,
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
      email: "",
      description: "",
    },
  });

  useEffect(() => {
    if (userData) {
      setValue("username", userData?.username);
      setValue("password", userData?.password);
      setValue("email", userData?.email);
      setValue("description", userData?.description);
    }
  }, [userData, setValue]);

  const { darkMode } = useContext(ThemeContext);

  const onDeleteClicked = () => {
    onDelete(userData.userid);
  };

  const onSave = (data) => {
    onEdit(data);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ fontSize: "30px", pb: 0 }}>Edit User</DialogTitle>

      <form onSubmit={handleSubmit(onSave)}>
        <DialogContent sx={{ pt: 0 }}>
          <FormControl fullWidth margin="normal">
            <TextField
              label="User Name"
              placeholder="Enter User Name"
              {...register("username", {
                required: "User Name is required",
              })}
              error={!!errors.username}
              helperText={errors.username?.message}
            />
          </FormControl>

          <FormControl fullWidth margin="normal">
            <TextField
              label="Password"
              placeholder="Enter Password"
              {...register("password", {
                required: "Password is required",
              })}
              error={!!errors.password}
              helperText={errors.password?.message}
            />
          </FormControl>

          <FormControl fullWidth margin="normal">
            <TextField
              label="Email"
              placeholder="Enter Email"
              {...register("email", {
                required: "Email is required",
                validate: (value) =>
                  isEmail(value) || "Please enter a valid email address",
              })}
              error={!!errors.email}
              helperText={errors.email?.message}
            />
          </FormControl>

          <FormControl fullWidth margin="normal">
            <TextField
              label="Description"
              multiline
              rows={4}
              placeholder="Enter Description"
              {...register("description", {
                required: "Description is required",
              })}
              error={!!errors.description}
              helperText={errors.description?.message}
            />
          </FormControl>

          {/* Frequency Dropdown */}
        </DialogContent>
        <DialogActions sx={{ pt: 0, mr: 2 }}>
          <Button
            sx={{
              borderRadius: "5px",
              fontFamily: "Poppins",
              fontSize: "18px",
              fontWeight: 500,
              color: darkMode
                ? getColors.appBarBgLight
                : getColors.appBarBgDark,
              px: 4,
              py: 1,
              textAlign: "center",
              "&: hover": {
                background: "none",
                color: getColors.primaryMain,
              },
            }}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{
              borderRadius: "5px",
              fontFamily: "Poppins",
              fontSize: "18px",
              fontWeight: 500,
              px: 5,
              py: 1,
              mr: 1,
              textAlign: "center",
            }}
            onClick={onDeleteClicked}
          >
            Delete
          </Button>
          <Button
            type="submit"
            variant="contained"
            sx={{
              borderRadius: "5px",
              fontFamily: "Poppins",
              fontSize: "18px",
              fontWeight: 500,
              px: 5,
              py: 1,
              textAlign: "center",
            }}
          >
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
